import { useState } from 'react';
import { useDispatch } from 'react-redux';
import OtpInput from 'react-otp-input';
import {
  Checkbox,
  Typography,
  Button,
  Modal,
  Icon,
} from '@safedns/skydns-ui-react-lib';

import sprite from '../../icons/sprite.svg';

import { notificationSuccess } from '../../store/notificationReducer';
import otpStyles from './OtpInput.module.scss';
import styles from './PinDialog.module.scss';

function createNotification(message) {
  return {
    isNotification: true,
    type: 'success',
    message,
  };
}

const PinDialog = ({ onDialogAction, onCancel, pin, setPin }) => {
  const dispatch = useDispatch();
  const [isChecked, setCheckboxState] = useState(false);

  const checkboxStateHandler = () => {
    setCheckboxState((prevState) => !prevState);
  };

  const handlePaste = (event) => {
    const data = event.clipboardData.getData('text');

    setPin(data);
  };

  const copyToClipboard = (_e) => {
    navigator.clipboard.writeText(pin);

    dispatch(
      notificationSuccess(createNotification('Ключ скопирован в буфер обмена'))
    );
  };

  return (
    <Modal
      isOpen={true}
      title="Задайте PIN-код для агента"
      onClose={onCancel}
      sx={{ maxWidth: 460 }}
    >
      <div className={styles['dialog-content']}>
        <Typography sx={{ paddingBottom: 11, letterSpacing: '0.16px' }}>
          Этот PIN потребуется при первом установке и авторизации агента.
        </Typography>
        <Typography
          sx={{ paddingBottom: 32, letterSpacin: '0.16px' }}
          className={styles['description-text']}
        >
          Сохраните его в надежном месте — после <br /> закрытия окна он больше
          не будет отображаться.
        </Typography>
        <div className={styles['pin-input-container']}>
          <div className={styles['pin-input-header']}>
            <Typography component="h3" className={styles['pin-input-title']}>
              Введите PIN-код
            </Typography>
            <Button
              variant="icon"
              isIconButton
              className={styles['copy-button']}
              onClick={copyToClipboard}
            >
              <Icon id="copy" sprite={sprite} width={20} height={20} />
            </Button>
          </div>
          <OtpInput
            value={pin}
            numInputs={6}
            inputType="number"
            shouldAutoFocus
            skipDefaultStyles
            containerStyle={{
              justifyContent: 'space-between',
            }}
            renderInput={(props) => (
              <input required {...props} className={otpStyles['otp-input']} />
            )}
            onChange={setPin}
            onPaste={handlePaste}
          />
        </div>
        <Checkbox
          id="save-control"
          label="Я сохранил(а) ключ"
          isChecked={isChecked}
          onChange={checkboxStateHandler}
          className={styles['checkbox-wrapper']}
        />
        <div className={styles['button-grid']}>
          <Button
            variant="secondary"
            className={styles['button-cancel']}
            onClick={onCancel}
          >
            Отменить
          </Button>
          <Button
            variant="primary"
            isDisabled={!isChecked || pin.length < 6}
            className={styles['button-submit']}
            onClick={onDialogAction}
          >
            Собрать агент
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PinDialog;
